module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "competition"
  }, [_c('Heading', [_vm._v("Добавляем новый конкурс")]), _c('Form', {
    attrs: {
      "grid": true,
      "inner": true
    }
  }, [_c('Select', {
    attrs: {
      "name": "level_id",
      "label": "Уровень конкурса",
      "placeholder": "Выберите уровень",
      "error-text": "Необходимо выбрать уровень конкурса",
      "options": _vm.competitionLevel,
      "v": _vm.$v.competitionForm.level,
      "required": true
    },
    model: {
      value: (_vm.competitionForm.level),
      callback: function($$v) {
        _vm.$set(_vm.competitionForm, "level", $$v)
      },
      expression: "competitionForm.level"
    }
  }), _c('Select', {
    attrs: {
      "name": "level_id",
      "label": "Участие индивидуально или в составе команды/группы",
      "placeholder": "Выберите тип участия",
      "error-text": "Необходимо выбрать тип участия",
      "options": _vm.nokoCompetitionTypes,
      "v": _vm.$v.competitionForm.type,
      "required": true
    },
    model: {
      value: (_vm.competitionForm.type),
      callback: function($$v) {
        _vm.$set(_vm.competitionForm, "type", $$v)
      },
      expression: "competitionForm.type"
    }
  }), _c('FormInput', {
    staticClass: "competition_wide",
    attrs: {
      "label": "Название конкурса",
      "placeholder": "Напишите название конкурса",
      "error-text": "Необходимо заполнить поле корректно",
      "v": _vm.$v.competitionForm.name,
      "required": true
    },
    model: {
      value: (_vm.competitionForm.name),
      callback: function($$v) {
        _vm.$set(_vm.competitionForm, "name", $$v)
      },
      expression: "competitionForm.name"
    }
  }), _c('FormInput', {
    attrs: {
      "label": "Название организатора",
      "placeholder": "Напишите название организатора",
      "error-text": "Необходимо заполнить поле корректно",
      "v": _vm.$v.competitionForm.organizer,
      "required": true
    },
    model: {
      value: (_vm.competitionForm.organizer),
      callback: function($$v) {
        _vm.$set(_vm.competitionForm, "organizer", $$v)
      },
      expression: "competitionForm.organizer"
    }
  }), _c('FormInput', {
    attrs: {
      "label": "Ссылка на сайт в интернете",
      "placeholder": "Напишите cсылку на сайт",
      "error-text": "Необходимо заполнить поле корректно",
      "v": _vm.$v.competitionForm.link,
      "required": true
    },
    model: {
      value: (_vm.competitionForm.link),
      callback: function($$v) {
        _vm.$set(_vm.competitionForm, "link", $$v)
      },
      expression: "competitionForm.link"
    }
  }), _c('Button', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.submitCompetitionForm
    }
  }, [_vm._v("Сохранить конкурс")]), _c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('form', 'add')
      }
    }
  }, [_vm._v("Назад")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-550818fa","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/progress/forms/competitionform/AddCompetition.vue
// module id = cf67fb0a6011affad54a
// module chunks = 42